module.exports = __webpack_public_path__ + "6893d1563bcba6a144dec278ee340349.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_6_a.png
// module id = 170
// module chunks = 0